import React from "react";
import styled, { keyframes } from "styled-components";

import { ReactComponent as Tea } from "./tea.svg";

/*
  Copyright (c) 2022 by Andreas Storm (https://codepen.io/avstorm/pen/RwNzPNN)
*/
const swing = keyframes`
  50% {
    transform: rotate(-3deg);
  }
`;

const steamLarge = keyframes`
  0% {
    stroke-dashoffset: 13;
    opacity: 0.6;
  }
  100% {
    stroke-dashoffset: 39;
    opacity: 0;
  }
`;

const steamSmall = keyframes`
  10% {
    stroke-dashoffset: 9;
    opacity: 0.6;
  }
  80% {
    stroke-dashoffset: 27;
    opacity: 0;
  }
  100% {
    stroke-dashoffset: 27;
    opacity: 0;
  }
`;

const IconContainer = styled.div`
  & > svg.tea {
    width: 55px;
    height: 72px;
    --secondary: #fff;
    & > #teabag {
      transform-origin: top center;
      transform: rotate(3deg);
      animation: ${swing} 2s infinite;
    }
    & > #steamL {
      stroke-dasharray: 13;
      stroke-dashoffset: 13;
      animation: ${steamLarge} 2s infinite;
    }
    & > #steamR {
      stroke-dasharray: 9;
      stroke-dashoffset: 9;
      animation: ${steamSmall} 2s infinite;
    }
  }
`;

const Loader = () => (
  <IconContainer>
    <Tea />
  </IconContainer>
);

export default Loader;
